<div class="card">
  <div class="card-body">
    <h5>{{ "Danh Sách Tin Nhắn ZNS" | translate }}</h5>
    <div class="">
      <div class="row">
        <!-- <div class="form-group col-3">
            <label for="validationCustom01"
              >{{ 'Chọn đối tác' | translate }}</label
            >
            <ng-select
              [(ngModel)]="filter.referrer"
              [clearable]="true"
              (change)="submitFilter()"
            >
              <ng-option value="" hidden
                >{{ 'Trạng thái giao hàng' | translate }}</ng-option
              >
              <ng-option *ngFor="let item of listAff" [value]="item.value"
                >{{ item.label }}</ng-option
              >
            </ng-select>
          </div> -->
        <div class="form-group col-md-3">
          <label for="validationCustom01">{{
            "Chọn trạng thái" | translate
          }}</label>
          <ng-select
            [(ngModel)]="filter.status"
            [clearable]="true"
            (change)="submitFilter()"
          >
            <ng-option *ngFor="let item of listStatus" [value]="item.value">{{
              item.label
            }}</ng-option>
          </ng-select>
        </div>
        <div class="form-group col-md-3">
          <label for="validationCustom01">{{
            "Số tài khoản" | translate
          }}</label>
          <input
            type="tel"
            class="form-control"
            [(ngModel)]="filter.acc_number"
            placeholder="Nhập số tài khoản"
            (change)="submitFilter()"
          />
        </div>
        <div class="form-group col-md-3">
          <label for="validationCustom01">{{
            "Số điện thoại" | translate
          }}</label>
          <input
            type="tel"
            class="form-control"
            [(ngModel)]="filter.phone"
            placeholder="Nhập số điện thoại"
            (change)="submitFilter()"
          />
        </div>
        <div class="form-group col-md-3">
          <label for="validationCustom01">{{
            "Khoảng thời gian lần cuối gửi" | translate
          }}</label>
          <ng-select
            [(ngModel)]="filter.dayRange"
            [clearable]="true"
            (change)="submitFilter()"
          >
            <ng-option value="" hidden>{{
              "Chọn khoảng thời gian lần cuối gửi tin nhắn" | translate
            }}</ng-option>
            <ng-option *ngFor="let item of listDayRange" [value]="item.value">{{
              item.label
            }}</ng-option>
          </ng-select>
        </div>
        <div class="form-group col-md-3">
          <label for="validationCustom01">{{ "Số lần gửi" | translate }}</label>
          <input
            type="tel"
            class="form-control"
            [(ngModel)]="filter.send_count"
            placeholder="Nhập số lần gửi"
            (change)="submitFilter()"
          />
        </div>
        <div class="form-group col-md-3 d-flex mt-2">
          <div class="col-4">
            <div style="min-width: 200px">
              <div class="form-group">
                <label for="validationCustom01" class="d-block">&nbsp;</label>
                <button class="btn btn-primary" (click)="submitFilter()">
                  {{ "PAGE.REPORT.Search" | translate }}
                </button>
                <button
                  class="btn btn-dark ml-2"
                  *ngIf="searching"
                  (click)="clearFilter()"
                >
                  {{ "FORM.Clear" | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex">
          <div class="form-group col-md-3 mt-2">
            <button
              class="btn p-2 btn-outline-success"
              (click)="openModal(contentSentMess)"
            >
              Gửi tin tới khách hàng
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="d-md-flex justify-content-md-between">
      <h6 class="">Tổng số tin nhắn: {{ dataHead?.totalMessages }}</h6>
      <h6 class="">Đã gửi: {{ dataHead?.totalSentMessages }}</h6>
      <h6 class="">Chưa gửi: {{ dataHead?.totalNotSentMessages }}</h6>
      <h6 class="">Gửi lỗi : {{ dataHead?.totalFailedMessages }}</h6>
    </div>
    <div class="table-responsive">
      <table
        id="basic-datatable"
        class="table table-bordered dt-responsive nowrap no-footer dtr-inline"
      >
        <thead>
          <tr class="bg-table">
            <th>#</th>
            <th class="first-column">{{ "Tên KH" | translate }}</th>
            <th>{{ "Số tài khoản" | translate }}</th>
            <th>{{ "Số điện thoại" | translate }}</th>
            <th>{{ "Số lượng" | translate }}</th>
            <th>{{ "Loại TB" | translate }}</th>
            <th>{{ "Gói DV" | translate }}</th>
            <th>{{ "Trạng thái" | translate }}</th>
            <th>{{ "Note lỗi" | translate }}</th>
            <th>{{ "Lần gửi" | translate }}</th>
            <th class="table-column">{{ "Ngày gửi" | translate }}</th>
            <th>{{ "Ngày hết hạn" | translate }}</th>
            <th>{{ "Còn lại" | translate }}</th>
            <th width="100" *ngIf="role !== 'operation'">
              {{ "Quản lý" | translate }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of listData; let i = index">
            <td class="table-column">
              {{ pageSize * (pageIndex - 1) + i + 1 }}
            </td>

            <td class="table-column">{{ data.full_name }}</td>
            <td class="table-column">{{ data.acc_number }}</td>
            <td class="table-column">{{ data.phone }}</td>
            <td class="table-column">{{ data.packages?.devices.length }}</td>
            <td class="table-column">
              {{ data.packages?.devices[0]?.device_type_name }}
            </td>

            <td class="table-column">
              <span
                class="font-size-12"
                *ngIf="data.packages?.devices[0]?.service_package == 3"
                >{{ "Gói 3 tháng" | translate }}</span
              >
              <span
                class="font-size-12"
                *ngIf="data.packages?.devices[0]?.service_package == 6"
                >{{ "Gói 6 tháng" | translate }}</span
              >

              <span
                *ngIf="data.packages?.devices[0]?.service_package == 12"
                class="font-size-12"
                >{{ "Gói 12 tháng" | translate }}</span
              >
            </td>
            <td class="table-column">
              <span class="font-size-12">
                {{ getStatusLabel(data.status) }}
              </span>
            </td>
            <td class="table-column">
              {{ data?.err_message }}
            </td>

            <td class="table-column">{{ data.send_count || 0 }} lần</td>
            <td class="table-column">
              {{ data.send_date | date : "dd/MM/yyyy" }}
            </td>
            <td class="table-column">
              {{ data.expiration_date | date : "dd/MM/yyyy" }}
            </td>
            <td class="table-column">{{ data.expire_in_days }} ngày</td>
            <td class="py-2 table-column">
              <div class="d-flex" style="gap: 5px">
                <a
                  class="font-size-18 text-success"
                  ngbTooltip="{{ 'Gửi tin nhắn' | translate }}"
                  placement="left"
                  (click)="sentMess(data)"
                >
                  <i class="ri-mail-send-fill"></i>
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row justify-content-md-between align-items-md-center mt-2">
      <div class="col-sm-12 col-md-5">
        <div
          class="dataTables_info mb-2"
          id="tickets-table_info"
          role="status"
          aria-live="polite"
        >
          {{ "TABLE.Showing" | translate }}
          {{ pageSize * pageIndex - pageSize + 1 }}
          {{ "TABLE.to" | translate }} {{ pageSize * pageIndex }}
          {{ "TABLE.of" | translate }} {{ totalCount }}
          {{ "TABLE.entries" | translate }}
        </div>
      </div>
      <!-- Pagination -->
      <div
        class="col-sm-12 col-md-5 d-flex align-items-center justify-content-end"
      >
        <div class="text-md-right float-md-right pagination-rounded">
          <ngb-pagination
            [collectionSize]="totalCount"
            [(page)]="pageIndex"
            [pageSize]="pageSize"
            [maxSize]="5"
            [ellipses]="true"
            (pageChange)="fetchData()"
          >
          </ngb-pagination>
        </div>
        <div class="dataTables_length ml-3" id="tickets-table_length">
          <label class="d-inline-flex align-items-center mb-0">
            {{ "TABLE.Show" | translate }}
            <select
              name="tickets-table_length"
              aria-controls="tickets-table"
              name="pageSize"
              [(ngModel)]="pageSize"
              (ngModelChange)="pageIndex = 1; fetchData()"
              class="custom-select custom-select-sm form-control form-control-sm mx-2"
            >
              <option [ngValue]="10">10</option>
              <option [ngValue]="25">25</option>
              <option [ngValue]="50">50</option>
              <option [ngValue]="100">100</option>
            </select>
            {{ "TABLE.entries" | translate }}
          </label>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #content role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">
      {{ (formData.value.id ? "FORM.Edit" : "FORM.AddNew") | translate }}
    </h5>
    <!-- <div *ngIf="makeForm('password').hasError('required')" class="error-message">
                Mật khẩu không được bỏ trống.
            </div> -->
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="saveData()" [formGroup]="formData">
        <div class="row">
          <!-- <div class="form-group row col-md-6">
                            <label class="col-md-2 col-form-label required_label">{{'Imei' | translate}}</label>
                            <div class="col-md-10">
                                <input type="text" class="form-control" formControlName="imei"
                                    [ngClass]="{'is-invalid': submitted && form.imei.errors}" />
                              
                            </div>
                        </div> -->
          <!-- <div class="form-group row col-md-12" *ngIf="!formData.value.id"> -->

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Serial" | translate
            }}</label>
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                formControlName="serial_number"
                [ngClass]="{
                  'is-invalid': submitted && form.serial_number.errors
                }"
              />
            </div>
          </div>
          <div class="form-group row col-md-12">
            <label class="col-md col-form-label required_label">{{
              "Model" | translate
            }}</label>
            <div class="col-md-10">
              <select
                class="form-select"
                aria-label="Default select example"
                class="form-control"
                formControlName="model"
                [ngClass]="{ 'is-invalid': submitted && form.model.errors }"
              >
                <option value="{{ item }}" *ngFor="let item of listModel">
                  {{ item }}
                </option>
              </select>
              <!-- <input type="text" class="form-control" formControlName="model"
                                    [ngClass]="{'is-invalid': submitted && form.model.errors}" />
                               -->
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Phiên bản" | translate
            }}</label>
            <div class="col-md-10">
              <select
                class="form-select"
                aria-label="Default select example"
                class="form-control"
                formControlName="version"
                [ngClass]="{ 'is-invalid': submitted && form.version.errors }"
              >
                <option value="{{ item }}" *ngFor="let item of listVersion">
                  {{ item }}
                </option>
              </select>
            </div>
          </div>
          <!-- <div class="form-group row col-md-12">
                            <label class="col-md-2 col-form-label required_label">{{'Trạng thái' | translate}}</label>
                            <div class="col-md-10">
                                <select class="form-select" aria-label="Default select example" class="form-control" formControlName="status"  [ngClass]="{'is-invalid': submitted && form.status.errors}">
                                    <option value="0" >Ngoại tuyến</option>
                                    <option value="1" >Trực tuyến</option>
                                </select>
                            </div>
                        </div>   -->
        </div>

        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <button
            type="submit"
            class="btn btn-success btn-lg"
            style="width: 150px"
          >
            {{ "Lưu" | translate }}
          </button>
          <!-- <button type="button" class="btn btn-secondary btn-sm" style="width: 150px"
                        (click)="modal('close click')">{{'FORM.Close' | translate}}</button>
                    <button type="button" class="btn btn-primary btn-sm ml-3" style="width: 150px"
                        (click)="updateFormNote()">{{'FORM.Save' | translate}}</button> -->
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #contentSentMess role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Gửi tin nhắn tới khách hàng</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="sendToUsers(formData.value)" [formGroup]="formData">
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-md-12 col-form-label required_label">
              {{ "Số lượng khách hàng gửi" | translate }}
            </label>
            <div>
              <div
                class="text-danger"
                *ngIf="formData.controls.data.errors?.required"
              >
                Giá trị là bắt buộc.
              </div>
              <div
                class="text-danger"
                *ngIf="formData.controls.data.errors?.min"
              >
                Giá trị phải không nhỏ hơn 1.
              </div>
              <div
                class="text-danger"
                *ngIf="formData.controls.data.errors?.max"
              >
                Giá trị phải không lớn hơn 100.
              </div>
            </div>
            <div class="col-md-12">
              <input
                type="number"
                class="form-control"
                formControlName="data"
                min="1"
                max="100"
                (keydown)="preventNegative($event)"
                [ngClass]="{
                  'is-invalid': submitted && formData.controls.data.invalid
                }"
              />
            </div>
          </div>
        </div>

        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <button
            type="submit"
            class="btn btn-success btn-lg"
            style="width: 150px"
            [disabled]="formData.controls.data.invalid"
          >
            {{ "Gửi" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>
